import { initAmpli } from "./amplitude";
import { initAppcues } from "./appcues";
import { initBeacon } from "./beacon";
import { initGA } from "./google-analytics";

export default function initProductTools() {
  if (process.env.NODE_ENV !== "test") {
    console.info("Initialising product tools ");
    initAmpli();
    initBeacon();
    initGA();
    initAppcues();
  }
}
